import { FunctionComponent, memo, useContext } from "react";
import urlJoin from "url-join";
import { InteractionContext } from "../interaction-context/interaction-context";
import Page from "constants/page";
import { faExpandArrowsAlt } from "@fortawesome/pro-solid-svg-icons";
import { IProps } from "./full-screen-link.types";
import { EllipsisMenuItem } from "@edgetier/client-components";
import { trackUser } from "utilities/track-user";
import "./full-screen-link.scss";

/**
 * Route link, when clicked will display the interaction in full screen
 * @param props.interactionId The ID of the interaction.
 */
const FullScreenLink: FunctionComponent<IProps> = ({ interactionId }) => {
    const { areWritingIssuesVisible } = useContext(InteractionContext);
    return (
        <EllipsisMenuItem
            icon={faExpandArrowsAlt}
            onClick={() => {
                trackUser("Expand interaction to full screen", { interactionId }, true);
            }}
            href={urlJoin(Page.Interaction, interactionId)}
            linkState={{ areWritingIssuesVisible }}
        >
            Open in full page
        </EllipsisMenuItem>
    );
};

export default memo(FullScreenLink);
